import { render, staticRenderFns } from "./AnimalEventHistory.vue?vue&type=template&id=e4886d32"
import script from "./AnimalEventHistory.vue?vue&type=script&lang=ts"
export * from "./AnimalEventHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports